import { ScrollableArea } from "@components/global/new/ScrollableArea/ScrollableArea";
import useLocationsNav from "@mobx/hooks/useLocationsNav";
import { useHasSelectedForDrag3 } from "@mobx/hooks/useSelectedForDrag";
import mainLocationsStore from "@mobx/store/locations";
import { IBuilding } from "@mobx/store/locations/types";
import { IBuildingInfo } from "@services/rackService";
import useMyMeta from "@utils/hooks/useMyMeta";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import BuildingBtn3 from "../BuildingBtn3";
import styles from "./Buildings.module.scss";

const useControl = () => {
  const locationStore = mainLocationsStore?.activeLocation;
  const locationId = locationStore?.location.Id;
  const buildings_ = useMemo(() => locationStore?.buildings ?? {}, [locationStore?.buildings]);
  const numBuildings = useMemo(() => Object.keys(buildings_).length, [buildings_]);
  const meta = useMyMeta();
  const reorderDisabled = useHasSelectedForDrag3("building");
  const { setActiveBuilding } = useLocationsNav();

  const buildings = useMemo(() => {
    const res = locationStore?.buildingsInOrder.map(s => s.building) ?? [];
    if (locationId === undefined) return res;
    const ord = meta.getLocationBuildingsOrder(""+locationId);
    if ((ord ?? []).length < Object.keys(buildings_).length) return res;
    const result: IBuilding[] = [];
    for (const id of ord!) {
      if (buildings_[+id] !== undefined) result.push(buildings_[+id].building);
    }
    if (result.length !== numBuildings) return res;
    return result;
  }, [buildings_, locationId]);

  const reorder_ = (b: IBuildingInfo[]) => {
    locationId !== undefined &&
      meta.setLocationBuildingsOrder(
        ""+locationId,
        b.map((bs) => bs.id)
      );
  };

  const onOpenCreateModal = () => {
    locationStore?.showAddBuildingModal();
  };

  return {
    buildings,
    locationId,
    reorderDisabled,
    locationStore,

    reorder: reorder_,
    onOpenCreateModal,
    setActiveBuilding,
  };
};

const Buildings3 = observer(() => {
  const ctrl = useControl();
  return (
    <div className={styles.scroll}>
      <ScrollableArea disableVertical>
        <div className={styles.building_name_wrapper}>
          {ctrl.buildings
            .sort((a, b) => (a?.ord ?? 0) - (b?.ord ?? 0))
            .map((item) => (
              <BuildingBtn3
                building={item}
                key={item.id}
                active={ctrl.locationStore?.activeBuilding?.building.id === item.id}
                onClick={() => ctrl.setActiveBuilding(item.id)}
              />
            ))}
          <BuildingBtn3 onClick={ctrl.onOpenCreateModal} />
        </div>
      </ScrollableArea>
    </div>
  );
});

Buildings3.displayName = "Buildings3";

export default Buildings3;